import { useEffect, useState } from "react";
import Tooltip from "../Inputs/Tooltip";
import { ModalBase } from "../Modals/ModalBase";
import HelpIcon from '../../media/felsv/help-circle-svgrepo-com.svg'
import '../../styles/help.css'
import { useSelector } from "react-redux";
import { State } from "../../reducers";

export default function Help ({simpleMessage, helpImage, modalTitle, id_message} : {simpleMessage: string | null, helpImage: any, modalTitle: string | undefined, id_message: string}){
    const [showImage, setshowImage] = useState(false)
    const {botonesAyuda} = useSelector((state: State) => state.catalogos)

    if(!botonesAyuda) return null

    return (
        <>
        {showImage &&
        <div style={{display: helpImage ? '' : 'none'}}>
            <ModalBase>
                <div className="help-image-container">
                <label style={{fontSize: '24px'}}>{modalTitle}</label>
                <img className="help-image" src={helpImage}/>
                <button className="help-image-button" onClick={() => setshowImage(false)}>Entendido</button>
                </div>
            </ModalBase>
        </div>
        }
        <Tooltip text={botonesAyuda[id_message] || simpleMessage}>
          <img onClick={() => setshowImage(true)} alt="?" src={HelpIcon} className="help-icon-button" loading="lazy"/>
        </Tooltip>
        </>
    )
}